<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"
      :field-readonly="true" />

    <!-- 비상대응조치계획 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 비상대응조치계획</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div class="form-title">절차/시나리오명</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.시나리오명 }}</p>
          <ml-input v-else :readonly="true" v-model="form.시나리오명" :max="300" :visible-counter="true"/>
        </div>

        <div>
          <div class="form-title">관리부서</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.관리부서 }}</p>
          <ml-input v-else :readonly="true" v-model="form.관리부서" :max="100" :visible-counter="true"/>
        </div>
      </div>
    </div>

    <!-- 교육훈련평가 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 교육훈련평가</h5>
      <div class="writeGridContainer">
        <div>
          <div class="form-title">평가결과</div>
          <p v-if="isPrint" class="print-input">{{ form.평가결과 }}</p>
          <vs-select v-model="form.평가결과" autocomplete v-else :readonly="board.readonly">
            <vs-select-item text="미완료" value="미완료" />
            <vs-select-item text="진행중" value="진행중" />
            <vs-select-item text="완료" value="완료" />
          </vs-select>
        </div>
        <div>
          <div class="form-title">결과서</div>
          <p v-if="isPrint" class="print-input flex-1">{{ form.결과서 }}</p>
          <file-uploader v-else v-model="form.결과서"/>
        </div>
        <div>
          <div class="form-title">교육훈련일</div>
          <p v-if="isPrint" class="print-input">{{ form.교육훈련일 }}</p>
          <date-selector v-else :readonly="board.readonly" v-model="form.교육훈련일" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />

    <popup-load-prev-board v-model="showLoadPrevBoard"
                           title="비상대응조치계획 수립 불러오기"
                           :set-board-id="741"
                           @selectRowData="prevBoardSelectRow" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";

export default {
  components: {
    PopupLoadPrevBoard,
    DateSelector,
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      showLoadPrevBoard: false,
      form: {
        stdInfo: {},
        fileList: [],

        시나리오명: "",
        관리부서: "",

        평가결과: "",
        결과서: {},
        교육훈련일: "",
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {
    prevBoardSelectRow(data) {
      let postContent = data.post_content;
      if (postContent) {
        postContent = JSON.parse(postContent);
        const year = postContent.header.year
        const body = postContent.body;

        this.header.year = year
        this.form.stdInfo.field_address = body.stdInfo.field_address
        this.form.stdInfo.field_id = body.stdInfo.field_id
        this.form.stdInfo.field_name = body.stdInfo.field_name
        this.form.시나리오명 = body.시나리오명;
        this.form.관리부서 = body.관리부서;
      }
    },

    setNormalBoardButtons(template) {
      const 비상대응조치계획수립불러오기 = {
        shouldShow: { mode: "c|u", freePass: 0, permission: "c|u", onlyWriter: true},
        component: "vs-button",
        props: { class: "col-span-2", color: "secondary", type: "border" },
        content: "비상대응조치계획 수립 불러오기",
        emits: {
          click: (func) => {
            this.showLoadPrevBoard = true;
          },
        },
      }
      return [ 비상대응조치계획수립불러오기, template.print, template.delete, template.move, template.save ]
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
